import { buildInitialValues } from '../helpers'
import type { LastDonationWidgetSettings } from './lastDonationWidgetSettingsSchema'
const DEFAULT_FONT_COLOR = 'ffffff'
const DEFAULT_DATA_COLOR = '9ECB0A'
const DEFAULT_FONT = 'Fira Sans'
const DEFAULT_FONT_WEIGHT = 400
const BOLD_FONT_WEIGHT = 700
const DEFAULT_FONT_SIZE = 18

const defaultValues = {
  darkMode: true,
  textAlign: 'center',
  countOfLines: 'multi',

  headlineFont: DEFAULT_FONT,
  headlineFontWeight: BOLD_FONT_WEIGHT,
  headlineFontSize: 32,
  headlineFontColor: DEFAULT_FONT_COLOR,
  headlineText: 'Letzte Spende',

  dataFont: DEFAULT_FONT,
  dataFontWeight: BOLD_FONT_WEIGHT,
  dataFontSize: 24,
  dataFontColor: DEFAULT_DATA_COLOR,

  screenNameFont: DEFAULT_FONT,
  screenNameFontWeight: DEFAULT_FONT_WEIGHT,
  screenNameFontSize: DEFAULT_FONT_SIZE,
  screenNameFontColor: DEFAULT_FONT_COLOR,

  commentFont: DEFAULT_FONT,
  commentFontWeight: DEFAULT_FONT_WEIGHT,
  commentFontSize: DEFAULT_FONT_SIZE,
  commentFontColor: DEFAULT_FONT_COLOR,
  shouldShowComment: true,
} satisfies LastDonationWidgetSettings
const getDefaultValues = buildInitialValues(defaultValues as LastDonationWidgetSettings)

export default getDefaultValues
